import {
    GTMEventPromotionData,
    PromotionImpressionAnalyticsEvent,
} from "@hermes/fragments/analytics";

export interface PromotionImpressionShopLocatorData {
    shops: Array<{ name: string; position: number; id: string }>;
}
export class PromotionImpressionShopLocator extends PromotionImpressionAnalyticsEvent {
    public override eventData!: PromotionImpressionShopLocatorData;

    constructor(eventData: PromotionImpressionShopLocatorData) {
        super(eventData);
    }
    /**
     * Overload formatForGTM of inherited class
     * Return formatter for eventaction and eventlabel key
     */
    public override formatForGTM(): GTMEventPromotionData {
        const promotions = this.eventData.shops.map((shop) => ({
            name: "Store locator search results",
            position: `${shop.name}::${shop.position}`,
            id: shop.id,
            creative: "",
        }));

        return {
            ...super.formatForGTM(),
            ecommerce: {
                promoView: {
                    promotions,
                },
            },
        };
    }
}
